import type { TradingAccount } from '../types';
import type { SimplifiedAccountEntry, UserSimplifiedStats } from '../types/simplifiedStats';

export function simplifiedEntryToTradingAccount(
  accountId: string,
  entry: SimplifiedAccountEntry,
  userId: string,
): TradingAccount {
  return {
    id: accountId,
    userId,
    name: entry.name ?? 'Compte',
    initialBalance: entry.initialBalance,
    currentBalance: entry.currentBalance,
    currency: entry.currency ?? 'USD',
    createdAt: '',
    isDisabled: entry.isDisabled === true,
    deleted: entry.deleted === true,
    accountVerified: entry.accountVerified,
    platform: entry.platform as TradingAccount['platform'],
    accountCategory: entry.accountCategory as TradingAccount['accountCategory'],
    propFirm: entry.propFirm as TradingAccount['propFirm'],
  };
}

export function buildAccountsFromSimplified(
  userId: string | undefined,
  simplified: UserSimplifiedStats | null,
): TradingAccount[] {
  if (!userId || !simplified?.accounts) {
    return [];
  }

  return Object.entries(simplified.accounts).map(([id, entry]) =>
    simplifiedEntryToTradingAccount(id, entry, userId),
  );
}

export function getActiveAccounts(accounts: TradingAccount[]): TradingAccount[] {
  return accounts.filter((acc) => !acc.deleted && !acc.isDisabled);
}

export function mergeAccountWithSimplifiedEntry(
  account: TradingAccount,
  entry: SimplifiedAccountEntry | null | undefined,
): TradingAccount {
  if (!entry) {
    return account;
  }

  return {
    ...account,
    name: entry.name ?? account.name,
    initialBalance: entry.initialBalance,
    currentBalance: entry.currentBalance,
    currency: entry.currency ?? account.currency,
    isDisabled: entry.isDisabled === true,
    deleted: entry.deleted === true,
    accountVerified: entry.accountVerified ?? account.accountVerified,
    platform: (entry.platform as TradingAccount['platform']) ?? account.platform,
    accountCategory: (entry.accountCategory as TradingAccount['accountCategory']) ?? account.accountCategory,
    propFirm: (entry.propFirm as TradingAccount['propFirm']) ?? account.propFirm,
  };
}
